import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M10 21h4v-9h5v-4h-5v-5h-4v5h-5v4h5z","key":"svg-0"}]]

const IconCross = createReactComponent('outline', 'cross', 'Cross', __iconNode);

export default IconCross;